/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        var searchKeyName = ApiKeyNames.search;

        return function() {
            return {
                search: requestFactory.single(endpoints.search, searchKeyName),
                batch: requestFactory.batch(100, {
                    single: endpoints.batchSearchQuery,
                    batchSync: endpoints.batchSyncSearch,
                    batch: endpoints.batchSearch
                }, searchKeyName)
            };
        };
    }
);



// WEBPACK FOOTER //
// ./rest/search.js